import React, { useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./style/MosquitoLanding.css";
import TestimonialSection from "./TestimonialSection";
import FAQSection from "./FAQSection";

const services = [
  { title: "Mosquito Net for Window", image: "/assets/mosquito-windows.webp" },
  { title: "Mosquito Net for Doors", image: "/assets/mosquito-doors.webp" },
  { title: "Mosquito Net for Balcony", image: "/assets/mosquito-balcony.webp" },
  { title: "Barrier Free Mosquito Net", image: "/assets/Barrierfree.jpg" },
  { title: "Do it Yourself ( DIY ) Range", image: "/assets/diyimage.jpg" },
  { title: "Mosquito Mesh Rolls", image: "/assets/mosquito-roll.webp" },
];

export default function MosquitoLanding() {
  const [formData, setFormData] = useState({ name: "", phone: "" });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // ✅ Client-side validation
    if (!formData.name.trim()) {
      toast.error("Please enter your name");
      return;
    }

    if (!formData.phone.trim()) {
      toast.error("Please enter your phone number");
      return;
    }

    const phoneRegex = /^[0-9]{10,15}$/;
    if (!phoneRegex.test(formData.phone)) {
      toast.error("Please enter a valid phone number (10 to 15 digits)");
      return;
    }

    try {
      const response = await fetch(
        "https://shalishaenterprise.com/backend/submit_form.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(formData),
        }
      );

      const data = await response.json();

      if (response.ok && data.apiresponse?.code === "0000") {
        toast.success(data.apiresponse.message || "Message sent successfully!");
        setFormData({ name: "", phone: "" });

        setTimeout(() => {
          window.location.href =
            "https://shalishaenterprise.com/backend/thank_you.php";
        }, 2000);
      } else {
        toast.error(data.apiresponse?.message || "Failed to send message");
      }
    } catch (err) {
      toast.error("An error occurred. Please try again.");
      console.error("Form error:", err);
    }
  };

  return (
    <>
      <section
        id="enquiry"
        className="slider"
        style={{
          backgroundImage: `url("./assets/mosquitonet.webp")`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="container">
          <div className="row align-items-center">
            <div className="col-xl-8 col-lg-12">
            <ToastContainer />
              <div className="slide__content text-white">
                <h2 className="slide__title">Mosquito Protection Solutions</h2>
                <p className="slide__desc">
                  Protect your home from mosquitoes with our premium mosquito net installations. Book a FREE consultation today and keep your family safe!
                </p>
              </div>
            </div>

            <div className="col-sm-4 col-md-4">
              <div className="intro-form bg-white p-4 rounded shadow">
                <h4>Get Professional Mosquito Protection</h4>
                <form onSubmit={handleSubmit} noValidate>
                  <fieldset>
                    <input
                      placeholder="Name"
                      required
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      className="form-control mb-2"
                    />
                    <input
                      placeholder="Mobile No."
                      required
                      type="tel"
                      name="phone"
                      className="form-control mb-3"
                      minLength="10"
                      maxLength="15"
                      value={formData.phone}
                      onChange={handleChange}
                    />
                    <button
                      className="btn btn-block btn-lg btn-orange"
                      type="submit"
                    >
                      Submit Now
                    </button>
                  </fieldset>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="mosquito-wrapper text-white text-center py-5 px-3 mobileview">
        <h2 className="fw-bold mb-4">What We Do</h2>
        <div className="container">
          <div className="row g-4 justify-content-center">
            {services.map((service, index) => (
              <div
                key={index}
                className="col-12 col-sm-6 col-lg-4"
                data-aos="zoom-in-up"
              >
                <div className="service-card rounded-4 overflow-hidden h-100">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="service-image"
                  />
                  <div className="p-3">
                    <h5 className="service-title">{service.title}</h5>
                    <a
                      href="#enquiry"
                      className="btn btn-sm w-100 text-light btn-mosquito p-2"
                    >
                      Send Enquiry
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <TestimonialSection />
      <FAQSection />
    </>
  );
}



// import React, { useState } from "react";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import "bootstrap/dist/css/bootstrap.min.css";
// import "./style/MosquitoLanding.css";
// import TestimonialSection from "./TestimonialSection";
// import FAQSection from "./FAQSection";

// const services = [
//   { title: "Mosquito Net for Window", image: "/assets/mosquito-windows.webp" },
//   { title: "Mosquito Net for Doors", image: "/assets/mosquito-doors.webp" },
//   { title: "Mosquito Net for Balcony", image: "/assets/mosquito-balcony.webp" },
//   { title: "Barrier Free Mosquito Net", image: "/assets/Barrierfree.jpg" },
//   { title: "Do it Yourself ( DIY ) Range", image: "/assets/diyimage.jpg" },
//   { title: "Mosquito Mesh Rolls", image: "/assets/mosquito-roll.webp" },
// ];

// export default function MosquitoLanding() {
//   const [formData, setFormData] = useState({ name: "", phone: "" });

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault(); // ✅ Prevent default submit

//     try {
//       const response = await fetch(
//         "https://shalishaenterprise.com/backend/submit_form.php",
//         {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify(formData),
//         }
//       );

//       const data = await response.json();

//       if (response.ok && data.apiresponse?.code === "0000") {
//         toast.success(data.apiresponse.message || "Message sent successfully!");
//         setFormData({ name: "", phone: "" });

//         // ✅ Redirect to thank you page after slight delay
//         setTimeout(() => {
//           window.location.href =
//             "https://shalishaenterprise.com/backend/thank_you.php";
//         }, 2000);
//       } else {
//         toast.error(data.apiresponse?.message || "Failed to send message");
//       }
//     } catch (err) {
//       toast.error("An error occurred. Please try again.");
//       console.error("Form error:", err);
//     }
//   };

//   return (
//     <>
//       <section
//         id="enquiry"
//         className="slider"
//         style={{
//           backgroundImage: `url("./assets/mosquitonet.webp")`,
//           backgroundSize: "cover",
//           backgroundPosition: "center",
//           backgroundRepeat: "no-repeat",
//         }}
//       >
//         <div className="container">
//           <div className="row align-items-center">
//             <ToastContainer />
//             <div className="col-xl-8 col-lg-12">
//               <div className="slide__content text-white">
//                 <h2 className="slide__title">Mosquito Protection Solutions</h2>
//                 <p className="slide__desc">
//                   Protect your home from mosquitoes with our premium mosquito net installations. Book a FREE consultation today and keep your family safe!
//                 </p>
//               </div>
//             </div>

//             <div className="col-sm-4 col-md-4">
//               <div className="intro-form bg-white p-4 rounded shadow">
//                 <h4>Get Professional Mosquito Protection</h4>
//                 <form onSubmit={handleSubmit} noValidate> {/* ✅ no action here */}
//                   <fieldset>
//                     <input
//                       placeholder="Name"
//                       required
//                       type="text"
//                       name="name"
//                       value={formData.name}
//                       onChange={handleChange}
//                       className="form-control mb-2"
//                     />
//                     <input
//                       placeholder="Mobile No."
//                       required
//                       type="tel"
//                       name="phone"
//                       className="form-control mb-3"
//                       minLength="10"
//                       maxLength="15"
//                       value={formData.phone}
//                       onChange={handleChange}
//                     />
//                     <button
//                       className="btn btn-block btn-lg btn-orange"
//                       type="submit"
//                     >
//                       Submit Now
//                     </button>
//                   </fieldset>
//                 </form>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       <div className="mosquito-wrapper text-white text-center py-5 px-3 mobileview">
//         <h2 className="fw-bold mb-4">What We Do</h2>
//         <div className="container">
//           <div className="row g-4 justify-content-center">
//             {services.map((service, index) => (
//               <div
//                 key={index}
//                 className="col-12 col-sm-6 col-lg-4"
//                 data-aos="zoom-in-up"
//               >
//                 <div className="service-card rounded-4 overflow-hidden h-100">
//                   <img
//                     src={service.image}
//                     alt={service.title}
//                     className="service-image"
//                   />
//                   <div className="p-3">
//                     <h5 className="service-title">{service.title}</h5>
//                     <a
//                       href="#enquiry"
//                       className="btn btn-sm w-100 text-light btn-mosquito p-2"
//                     >
//                       Send Enquiry
//                     </a>
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>

//       <TestimonialSection />
//       <FAQSection />
//     </>
//   );
// }


// import React, { useState } from "react";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import "bootstrap/dist/css/bootstrap.min.css";
// import "./style/MosquitoLanding.css";
// import TestimonialSection from "./TestimonialSection";
// import FAQSection from "./FAQSection";

// const services = [
//   {
//     title: "Mosquito Net for Window",
//     image: "/assets/mosquito-windows.webp",
//   },
//   {
//     title: "Mosquito Net for Doors",
//     image: "/assets/mosquito-doors.webp",
//   },
//   {
//     title: "Mosquito Net for Balcony",
//     image: "/assets/mosquito-balcony.webp",
//   },
//   {
//     title: "Barrier Free Mosquito Net",
//     image: "/assets/Barrierfree.jpg",
//   },
//   {
//     title: "Do it Yourself ( DIY ) Range",
//     image: "/assets/diyimage.jpg",
//   },
//   {
//     title: "Mosquito Mesh Rolls",
//     image: "/assets/mosquito-roll.webp",
//   },
// ];

// export default function MosquitoLanding() {
//    const [formData, setFormData] = useState({
//     name: "",
//     phone: "",
//   });
  
//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prevState) => ({
//       ...prevState,
//       [name]: value,
//     }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     try {
//       const response = await fetch(
//         "https://shalishaenterprise.com/backend/submit_enquiry.php",
//         {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify(formData),
//         }
//       );

//       const data = await response.json();

//       if (response.ok) {
//         toast.success(
//           data.apiresponse.message || "Message sent successfully!",
//           {
//             position: "top-center",
//             autoClose: 5000,
//             hideProgressBar: false,
//             closeOnClick: true,
//             pauseOnHover: true,
//             draggable: true,
//           }
//         );
//         setFormData({ name: "", phone: "", }); // Reset form
//       } else {
//         toast.error(data.apiresponse?.message || "Failed to send message", {
//           position: "top-right",
//           autoClose: 5000,
//           hideProgressBar: false,
//           closeOnClick: true,
//           pauseOnHover: true,
//           draggable: true,
//         });
//       }
//     } catch (error) {
//       toast.error("An error occurred. Please try again.", {
//         position: "top-right",
//         autoClose: 5000,
//         hideProgressBar: false,
//         closeOnClick: true,
//         pauseOnHover: true,
//         draggable: true,
//       });
//       console.error("Error submitting form:", error);
//     }
//   };


//   return (
//     <>
//       <section
//         id="enquiry"
//         className="slider"
//         style={{
//           backgroundImage: `url(${"./assets/mosquitonet.webp"})`,
//           backgroundSize: "cover",
//           backgroundPosition: "center",
//           backgroundRepeat: "no-repeat",
//         }}
//       >
//         <div className="container">
//           <div className="row align-items-center">
//           <ToastContainer />
//             <div className="col-sm-12 col-md-12 col-lg-12 col-xl-8">
//               <div className="slide__content text-white">
//                 <h2 className="slide__title">Mosquito Protection Solutions</h2>
//                 <p className="slide__desc">
//                   Protect your home from mosquitoes with our premium mosquito net installations. Book a FREE consultation today and keep your family safe!
//                 </p>
//               </div>
//             </div>

//             <div className="col-sm-4 col-md-4">
//               <div className="intro-form bg-white p-4 rounded shadow">
//                 <h4>Get Professional Mosquito Protection</h4>
//                 <form onSubmit={handleSubmit}>
//                   <input name="form-type" value="contact" type="hidden" />
//                   <fieldset>
//                     <input
//                       placeholder="Name"
//                       required
//                       type="text"
//                       name="name"
//                       value={formData.name}
//                       onChange={handleChange}
//                     />
//                     <input
//                       placeholder="Mobile No."
//                       type="tel"
//                       name="phone"
//                       className="form-control"
//                       minLength="10"
//                       maxLength="15"
//                       required
//                       value={formData.phone}
//                       onChange={handleChange}
//                     />
//                     <button className="btn btn-block btn-lg btn-orange" type="submit">
//                       Submit Now
//                     </button>
//                   </fieldset>
//                 </form>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       <div className="mosquito-wrapper text-white text-center py-5 px-3 mobileview">
//         <h2 className="fw-bold mb-4">What We Do</h2>
//         <div className="container">
//           <div className="row g-4 justify-content-center">
//             {services.map((service, index) => (
//               <div key={index} className="col-12 col-sm-6 col-lg-4" data-aos="zoom-in-up">
//                 <div className="service-card rounded-4 overflow-hidden h-100">
//                   <img
//                     src={service.image}
//                     alt={service.title}
//                     className="service-image"
//                   />
//                   <div className="p-3">
//                     <h5 className="service-title">{service.title}</h5>
//                     <a href="#enquiry" className="btn btn-sm w-100 text-light btn-mosquito p-2">
//                       Send Enquiry
//                     </a>
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>
//       <TestimonialSection />
//       <FAQSection />
//     </>
//   );
// }





// // import React from "react";
// // import "bootstrap/dist/css/bootstrap.min.css";
// // import "./style/MosquitoLanding.css";
// // import TestimonialSection from "./TestimonialSection";
// // import FAQSection from "./FAQSection";

// // const services = [
// //   {
// //     title: "Mosquito Net for Window",
// //     image: "/assets/mosquito-windows.webp",
// //   },
// //   {
// //     title: "Mosquito Net for Doors",
// //     image: "/assets/mosquito-doors.webp",
// //   },
// //   {
// //     title: "Mosquito Net for Balcony",
// //     image: "/assets/mosquito-balcony.webp",
// //   },
// //   {
// //     title: "Barrier Free Mosquito Net",
// //     image: "/assets/Barrierfree.jpg",
// //   },
// //   {
// //     title: "Do it Yourself ( DIY ) Range",
// //     image: "/assets/diyimage.jpg",
// //   },
// //   {
// //     title: "Mosquito Mesh Rolls",
// //     image: "/assets/mosquito-roll.webp",
// //   },
// // ];

// // export default function MosquitoLanding() {
// //   return (
// //     <>
// //       <section
// //         id="enquiry"
// //         className="slider"
// //         style={{
// //           backgroundImage: `url(${"./assets/mosquitonet.webp"})`,
// //           backgroundSize: "cover",
// //           backgroundPosition: "center",
// //           backgroundRepeat: "no-repeat",
// //         }}
// //       >
// //         <div className="container">
// //           <div className="row align-items-center">
// //             <div className="col-sm-12 col-md-12 col-lg-12 col-xl-8">
// //               <div className="slide__content text-white">
// //                 <h2 className="slide__title">Mosquito Protection Solutions</h2>
// //                 <p className="slide__desc">
// //                   Protect your home from mosquitoes with our premium mosquito net installations. Book a FREE consultation today and keep your family safe!
// //                 </p>
// //               </div>
// //             </div>

// //             <div className="col-sm-4 col-md-4">
// //               <div className="intro-form bg-white p-4 rounded shadow">
// //                 <h4>Get Professional Mosquito Protection</h4>
// //                 <form action="submit.php" method="POST">
// //                   <input name="form-type" value="contact" type="hidden" />
// //                   <fieldset>
// //                     <input placeholder="Name" required type="text" name="name" />
// //                     <input
// //                       placeholder="Mobile No."
// //                       type="tel"
// //                       name="mobile"
// //                       className="form-control"
// //                       minLength="10"
// //                       maxLength="15"
// //                       required
// //                     />
// //                     <button className="btn btn-block btn-lg btn-orange" type="submit">
// //                       Submit Now
// //                     </button>
// //                   </fieldset>
// //                 </form>
// //               </div>
// //             </div>
// //           </div>
// //         </div>
// //       </section>

// //       <div className="mosquito-wrapper text-white text-center py-5 px-3 mobileview">
// //         <h2 className="fw-bold mb-4">What We Do</h2>
// //         <div className="container">
// //           <div className="row g-4 justify-content-center">
// //             {services.map((service, index) => (
// //               <div key={index} className="col-12 col-sm-6 col-lg-4" data-aos="zoom-in-up">
// //                 <div className="service-card rounded-4 overflow-hidden h-100">
// //                   <img
// //                     src={service.image}
// //                     alt={service.title}
// //                     className="service-image"
// //                   />
// //                   <div className="p-3">
// //                     <h5 className="service-title">{service.title}</h5>
// //                     <a href="#enquiry" className="btn btn-sm w-100 text-light btn-mosquito p-2">
// //                       Send Enquiry
// //                     </a>
// //                   </div>
// //                 </div>
// //               </div>
// //             ))}
// //           </div>
// //         </div>
// //       </div>
// //       <TestimonialSection />
// //       <FAQSection />
// //     </>
// //   );
// // }
  

// // import React from "react";
// // import "bootstrap/dist/css/bootstrap.min.css";
// // import "./style/MosquitoLanding.css"; // Assuming you have a CSS file for styles
// // import TestimonialSection from "./TestimonialSection";
// // import FAQSection from "./FAQSection";
// // // import ContactUs from "./ContactUs";
// // // import HeroSlider from "./HeroSlider";
// // const services = [
// //   {
// //     title: "Mosquito Net for Window",
// //     image: "/assets/mosquito-window.jpg",
// //   },
// //   {
// //     title: "Mosquito Net for Doors",
// //     image: "/assets/mosquito-doors.jpg",
// //   },
// //   {
// //     title: "Mosquito Net for Balcony",
// //     image: "/assets/mosquito-balcony.jpg",
// //   },
// //   {
// //     title: "Barrier Free Mosquito Net",
// //     image: "/assets/Barrierfree.jpg",
// //   },
// //   {
// //     title: "Do it Yourself ( DIY ) Range",
// //     image: "/assets/diyimage.jpg",
// //   },
// //   {
// //     title: "Mosquito Mesh Rolls",
// //     image: "/assets/rollimage.jpg",
// //   },
// // ];

// // export default function MosquitoLanding() {
// //   return (
// //     <>
// //     <section
// //   id="enquiry"
// //   className="slider"
// //   style={{
// //     backgroundImage: `url(${"./assets/mosquitonet.jpg"})`, // Change to a relevant mosquito net image
// //     backgroundSize: "cover",
// //     backgroundPosition: "center",
// //     backgroundRepeat: "no-repeat",
// //   }}
// // >
// //   <div className="container">
// //     <div className="row align-items-center">
// //       <div className="col-sm-12 col-md-12 col-lg-12 col-xl-8">
// //         <div className="slide__content text-white">
// //           <h2 className="slide__title">Mosquito Protection Solutions</h2> {/* Updated title */}
// //           <p className="slide__desc">
// //             Protect your home from mosquitoes with our premium mosquito net installations. Book a FREE consultation today and keep your family safe!
// //           </p>
// //         </div>
// //       </div>

// //       <div className="col-sm-4 col-md-4 ">
// //         <div className="intro-form bg-white p-4 rounded shadow">
// //           <h4>Get Professional Mosquito Protection</h4> {/* Updated heading */}
// //           <form action="submit.php" method="POST">
// //             <input name="form-type" value="contact" type="hidden" />
// //             <fieldset>
// //               <input placeholder="Name" required type="text" name="name" />
// //               <input
// //                 placeholder="Mobile No."
// //                 type="tel"
// //                 name="mobile"
// //                 className="form-control"
// //                 minLength="10"
// //                 maxLength="15"
// //                 required
// //               />
// //               <button className="btn btn-block btn-lg btn-orange" type="submit">
// //                 Submit Now
// //               </button>
// //             </fieldset>
// //           </form>
// //         </div>
// //       </div>
// //     </div>
// //   </div>
// // </section>

// //     <div className="mosquito-wrapper text-white text-center py-5 px-3 mobileview">
// //       <h2 className="fw-bold mb-4">What We Do </h2>
// //       {/* <p className="mb-5 ">
// //         Stylish, effective and reliable solutions to keep your space mosquito-free.
// //       </p> */}
// //       <div className="container">
// //         <div className="row g-4 justify-content-center">
// //         {services.map((service, index) => (
// //   <div key={index} className="col-12 col-sm-6 col-lg-4" data-aos="zoom-in-up">
// //     <div className="service-card rounded-4 overflow-hidden h-100">
// //       <img
// //         src={service.image}
// //         alt={service.title}
// //         className="service-image"
// //       />
// //       <div className="p-3">
// //         <h5 className="service-title">{service.title}</h5>
// //         <a href="#enquiry" className="btn btn-sm w-100 text-light btn-mosquito p-2">
// //           Send Enquiry
// //         </a>
// //       </div>
// //     </div>
// //   </div>
// // ))}

// //         </div>
// //       </div>
// //     </div>
// //     <TestimonialSection/>
// //     <FAQSection />
// //     </>
// //   );
// // }
